angular.module('MyApp')

  .controller('NavbarCtrl', function ($rootScope, $scope, $location, $auth, toastr, services) {
    /***************************************/

    $scope.url_ = $rootScope.url_;


    $scope.init3 = function () {
      if (typeof ($rootScope.user.nom) === 'undefined') $scope.nom = "";
      else $scope.nom = $rootScope.user.nom;
      if (typeof ($rootScope.user.mail) === "undefined") $scope.email = "";
      else $scope.email = $rootScope.user.mail;

      if ($scope.email == "demo") $scope.email = "";
    }

    $scope.initListe = function () {

      if (!$auth.isAuthenticated()) {  // pas connecté !
        $rootScope.token = undefined;
        $rootScope.reponses = [];
        $rootScope.user = [];
        $rootScope.user.mail = "";
        $rootScope.user.token = "";
        $rootScope.user.nom = "";
        localStorage.removeItem('token');
        localStorage.removeItem('mail');
        localStorage.removeItem('nom');
      } else {  // connecté !
        $rootScope.user = []
        $rootScope.user.mail = localStorage.getItem("mail");
        $rootScope.user.token = localStorage.getItem("token");
        $rootScope.user.nom = localStorage.getItem("nom");
        //$location.path('/');
      }
      //$rootScope.qcmSelectionne=[];
      // signup.js


      $scope.sujet = "";
      $scope.message = "";

      $scope.displayName = "";
      $scope.email = "";
      $scope.password1 = "";
      $scope.confirmPassword = "";
      $scope.faq = false;

    }

    $scope.etat = function (nb) { //revenir
      //$scope.etatPage=$rootScope.menu.etatPage;
      $rootScope.menu.etatPage = nb;
    }


    $scope.goto = function (val) {
      if (val == 2) {
        $rootScope.menu.etatPage = 2;
        $scope.displayName = "";
        $scope.email = "";
        $scope.password1 = "";
        $scope.confirmPassword = "";
      } else
        $rootScope.menu.etatPage = 1;
      $location.path('/');
    }

    $scope.gotoListe = function () {
      $location.path('/0lst');
    }

    $scope.menu1 = function (val) {
      $scope.menu1 = val;
      $rootScope.menu1 = val;
    }

    $scope.isAuthenticated = function () {
      if (typeof ($rootScope.menu1) == "undefined")
        $rootScope.menu1 = 1;

      $scope.menu1 = $rootScope.menu1;
      return $auth.isAuthenticated();
    };
    /***login************************************/
    $scope.login = function (val) {

      if (val == "demo") {
        $scope.user = [];
        $scope.user.email = "demo";
        $scope.user.password = "demo";
      }

      sessionStorage.removeItem("id");
      sessionStorage.removeItem("mail");
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("nom");


      delete $rootScope.qcmSelectionne;
      delete $rootScope.listeQCMlive;

      $rootScope.listeQCM = [];

      $auth.login({ email: $scope.user.email, password: $scope.user.password })
        .then(function (data) {

          //$cookies.put('mail', data.data.mail);
          //$cookies.put('id', data.data.idUser);
          localStorage.setItem("mail", data.data.mail);
          //localStorage.setItem("id",data.data.idUser);
          localStorage.setItem("token", data.data.token);
          localStorage.setItem("nom", data.data.nom);

          $rootScope.user = [];
          $rootScope.user.mail = data.data.mail;
          $rootScope.user.token = data.data.token;
          $rootScope.user.nom = data.data.nom;

          delete $rootScope.qcmSelectionne;
          delete $rootScope.listeQCMlive;
          delete $rootScope.listeQCM;
          toastr.success('___connexion réussie___!');
          /*          if ($scope.menu1_avant==10) $location.path('/1qcm');
                    else if ($scope.menu1_avant==60) $location.path('/l0');
                    else $location.path('/');
          */
          $location.path('/0lst');
        })
        .catch(function (response) {
          toastr.error(response.data.message, response.status);
        });
    };

    /*****/
    $scope.authenticate = function (provider) {

      $auth.authenticate(provider)
        .then(function () {
          toastr.success('___connexion réussie via___ ' + provider + '!');
          a = services.provider()
            .then(function (data) {
              $rootScope.user = [];
              $rootScope.user.mail = data.data.mail;
              $rootScope.user.photo = data.data.photo;
              $rootScope.user.nom = data.data.nom;
              $rootScope.user.token = $auth.getToken();
              delete $rootScope.qcmSelectionne;
              delete $rootScope.listeQCMlive;
              delete $rootScope.listeQCM;
              localStorage.setItem('token', $auth.getToken());
            })
            .finally(function () {
              $location.path('/0lst');
            });;

        })
        .catch(function (response) {
          if (response.message) {
            // Satellizer promise reject error.
            toastr.error(response.message);
          } else if (response.data) {
            // HTTP response error from server
            toastr.error(response.data.message, response.status);
          } else {
            toastr.error(response);
          }
        });
      localStorage.setItem('token', $auth.getToken())

    };


    /***************************************/
    $scope.signup = function (displayName, email, password1) {

      services.adduser({
        nom: displayName,
        email: email,
        password: password1
      }).then(function (response) {

        $auth.setToken(response);

        $rootScope.user = { 'mail': response.data.mail, 'token': response.data.token, 'nom': response.data.nom };

        toastr.info('___Votre compte a été créé. Vous voici connecté.___');

        $location.path('/0lst');
      })
        .catch(function (response) {
          toastr.error(response.data.message);
        });

    };
    /***************************************/
    $scope.mail_contact = function () {
      alert("mail_contact : " + $scope.email)
      services.mail_contact({ 'mail': $scope.email, 'nom': $scope.nom, 'sujet': $scope.sujet, 'message': $scope.message }).then(function () {
        toastr.info("___Votre message a été envoyé. J'essaye de vous répondre au vite. Merci.___");
        setTimeout(function () {
          $scope.nom = "";
          $scope.email = "";
          $scope.sujet = "";
          $scope.message = "";
        }, 350);

      });
    };
    /***************************************/
    $scope.forget = function (email) {
      services.mail(email)
        .then(function (data) {
          toastr.info('___Un nouveau mot de passe a été envoyé par mail___.');
          setTimeout(function () {
            $scope.email = "";
          }, 350);
        })
        .catch(function (response) {
          toastr.warning('___mail inconnu___.');
          alert("response=" + response.response.message)
        })
    };
    /***************************************/
    $scope.faq = function () {
      var url = $location.url();
      alert("faq");


    };


    /***************************************/

  });

